import { useState, useEffect } from 'react'

/**
 * Returns a pixel offset to push fixed-bottom elements above the virtual keyboard.
 * Uses the VisualViewport API; returns 0 on desktop or unsupported browsers.
 */
export function useKeyboardSafeBottom(): number {
  const [offset, setOffset] = useState(0)

  useEffect(() => {
    const vv = window.visualViewport
    if (!vv) return

    const update = () => {
      const diff = window.innerHeight - vv.height
      setOffset(diff > 50 ? diff : 0)
    }

    vv.addEventListener('resize', update)
    vv.addEventListener('scroll', update)
    return () => {
      vv.removeEventListener('resize', update)
      vv.removeEventListener('scroll', update)
    }
  }, [])

  return offset
}
